var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCertilyticsLogoIcons2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 98.7 98",
    style: {
      enableBackground: "new 0 0 98.7 98"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#011B3A;}\n\t.st1{fill:#5E5E5E;}\n\t.st2{fill:#F4695B;}\n\t.st3{fill:#1D54DD;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{opacity:0.8;fill:#E1EBFF;}\n\t.st6{fill:#D2D7D8;}\n\t.st7{fill:#828282;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "69.8,75.5 58.2,58.6 69.4,50.5 67.2,47.5 56.1,55.6 45.6,40.3 69.4,22.9 67.2,19.9 43.5,37.2  31.9,20.4 28.8,22.5 40.4,39.4 29.3,47.5 31.5,50.5 42.6,42.4 53.1,57.7 29.3,75.1 31.5,78.1 55.2,60.8 66.8,77.6  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 21.9,
    y: 13,
    className: "st2",
    width: 16.9,
    height: 16.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 59.9,
    y: 13,
    className: "st2",
    width: 16.9,
    height: 16.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 21.9,
    y: 40.6,
    className: "st2",
    width: 16.9,
    height: 16.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 59.9,
    y: 40.6,
    className: "st3",
    width: 16.9,
    height: 16.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 21.9,
    y: 68.1,
    className: "st3",
    width: 16.9,
    height: 16.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 59.9,
    y: 68.1,
    className: "st2",
    width: 16.9,
    height: 16.9
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertilyticsLogoIcons2);
export default __webpack_public_path__ + "static/media/Certilytics-Logo-Icons-2.e8b86d8539fd3ac9804a8f3b0ad400c3.svg";
export { ForwardRef as ReactComponent };